import React from 'react';
import NotFoundPresenter from './NotFoundPresenter';
import { useScrollTop } from '../../hooks';

const NotFoundContainer = () => {
  useScrollTop();
  return <NotFoundPresenter />;
};

export default NotFoundContainer;
